module.exports = __webpack_public_path__ + "static/media/cswap-emblem-orange.a9c0af2c.svg";